import { createContext } from 'react'
import { Permission } from './permissions.constants'

export interface User {
  sessionId: string,
  id: number,
  userId: string,
  firstName: string,
  lastName: string,
  teamId: number,
  teamName: string,
  fedRAMPCompliance: boolean,
  groupId: number,
  groupName: string,
  lang: string,
  country: string,
  sessionTimeout: string,
  timezoneString: string,
  deactivated: boolean,
  licenseCompliance: boolean,
  tenantId: number,
  tenantName: string,
  passwordExpirationDate: number | null,
  userIq: boolean,
  activatedDate: number,
  permissions: Permission[],
  groupsInScope: number[],
  teamsInScope: number[],
  serviceQueuesInScope: number[],
  roles: string[],
  isDx: boolean,
  teleoptiAdminUrl: string | null,
  teleoptiEnabled: boolean,
  useQmViewScope: boolean,
  authenticationMethod: string,
  pendoId: string,
  authenticationSource: string | null,
  subdomainUrl?: string | null,
}

export default createContext<User | null>(null)
